import { IApplicationState } from '../../types/redux';
import { getBBoxFromRegion } from '../../utils/geo';

export function selectBoundedBy(state: IApplicationState) {
  return getBBoxFromRegion(state.region.currentRegion);
}
